import { Component, Input, OnInit, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'cv-shadow-boxing-preview',
  templateUrl: './shadow-boxing-preview.component.html',
  styleUrls: ['./shadow-boxing-preview.component.scss']
})
export class ShadowBoxingPreviewComponent implements OnInit {

  @Input() difficulty: number = 1;
  @Input() metricName: string = '';
  @Input() dailyGoal: string = '';
  @Input() startDate: Date;
  @Input() gems: number = 1;

  endDate: string = '';
  startDateRange: any = null;
  endDateRange: any = null;
  showTooltip: boolean = false;
  tooltipStyle: any = {};
  hp: number = 2;

  @ViewChild('progressContainer', { static: false }) progressContainer!: ElementRef;

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
    const startDate = this.startDate ? new Date(this.startDate) : new Date();
    this.startDateRange = this.datePipe.transform(startDate, 'MM/dd/yyyy');

    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
    this.endDateRange = this.datePipe.transform(endDate, 'MM/dd/yyyy');

    this.endDate = this.datePipe.transform(this.endDateRange, 'M/d');
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['difficulty'] && changes['difficulty'].currentValue != null && changes['gems'] && changes['gems'].currentValue != null) {
      this.difficulty = changes['difficulty'].currentValue;
      this.hp = this.difficulty + 1;
      this.gems = changes['gems'].currentValue;
    }

    if (changes['startDate'] && changes['startDate'].currentValue != null) {
      const startDate = new Date(changes['startDate'].currentValue);
      this.startDateRange = this.datePipe.transform(startDate, 'MM/dd/yyyy');

      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      this.endDateRange = this.datePipe.transform(endDate, 'MM/dd/yyyy');

      this.endDate = this.datePipe.transform(this.endDateRange, 'M/d');
    }

  }

  toggleTooltip(show: boolean): void {
    this.showTooltip = show;

    if (show) {
      this.updateTooltipPosition();
    }
  }

  updateTooltipPosition(): void {
    const progressElement = this.progressContainer.nativeElement.querySelector('.progress');
    const tooltipElement = this.progressContainer.nativeElement.querySelector('.health-points-tooltip');

    if (progressElement && tooltipElement) {
      const progressRect = progressElement.getBoundingClientRect();
      const tooltipHeight = tooltipElement.offsetHeight;

      const tooltipTop = progressRect.top + window.scrollY - tooltipHeight;
      const tooltipLeft = progressRect.right + 10;

      this.tooltipStyle = {
        top: `${tooltipTop}px`,
        left: `${tooltipLeft}px`,
        display: 'block'
      };
    }
  }

}
